import { render, staticRenderFns } from "./passo1.vue?vue&type=template&id=1c709a58&scoped=true&"
import script from "./passo1.vue?vue&type=script&lang=js&"
export * from "./passo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c709a58",
  null
  
)

export default component.exports